const SAVED_CLASS = 'da-row--saved';
const LEAVING_CLASS = 'da-row--leaving';
const SAVED_MS = 1600;

const savedTimers = new WeakMap();

export const row = (id) => {
  const element = document.getElementById(id);
  if (!element) return null;

  clearTimeout(savedTimers.get(element));
  element.classList.remove(SAVED_CLASS);
  element.getBoundingClientRect();
  element.classList.add(SAVED_CLASS);
  savedTimers.set(element, setTimeout(() => element.classList.remove(SAVED_CLASS), SAVED_MS));

  return element;
};

export const leaving = (element, isLeaving = true) => {
  if (!element) return null;

  element.classList.toggle(LEAVING_CLASS, isLeaving);

  return element;
};
